export default __webpack_public_path__ + "static/media/23.a5cd373b.jpg";